module.exports = __webpack_public_path__ + "fonts/keto-ic.svg";